// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as RestApi$DvmAdminFrontendFr from "../../../api/RestApi.bs.js";

function editRow(userManager, setResult, submissionCallbacks, selectedRole, row, amount, tableType) {
  Curry._1(setResult, (function (param) {
          return /* Pending */1;
        }));
  RestApi$DvmAdminFrontendFr.WithEmptyResponse.call("PUT", undefined, userManager, selectedRole, (
          selectedRole === /* RMPC */9 ? "/resource/rmpc/mr?recipient=" + Belt_Option.getWithDefault(row.mr, "") + "" : "/resource/dpr/" + (
              tableType ? "mr?recipient=" + Belt_Option.getWithDefault(row.mr, "") + "" : "rmpc?recipient=" + Belt_Option.getWithDefault(row.rmpc, "") + ""
            )
        ) + ("&period=" + row.periodID + "&year=" + row.year + "&amount=" + String(amount) + "")).then(function (result) {
        if (result.TAG === /* OkResult */0) {
          Curry._1(submissionCallbacks.notifyOnSuccess, undefined);
          return Curry._1(setResult, (function (param) {
                        return {
                                TAG: /* Ok */0,
                                _0: undefined
                              };
                      }));
        }
        var error = result._0;
        Curry._1(submissionCallbacks.notifyOnFailure, /* FailedToUpdatePoolExpense */0);
        Curry._1(setResult, (function (param) {
                return {
                        TAG: /* Error */1,
                        _0: error
                      };
              }));
      });
}

var Form;

export {
  Form ,
  editRow ,
}
/* RestApi-DvmAdminFrontendFr Not a pure module */
